var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.077,
    height: 20,
    viewBox: "0 0 23.077 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #203662;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27348",
    "data-name": "Path 27348",
    className: "cls-1",
    d: "M13.009,2.164a.777.777,0,0,0-.956,0L1,10.784l.956,1.209,1.352-1.054v9.522A1.542,1.542,0,0,0,4.846,22H20.231a1.541,1.541,0,0,0,1.538-1.538V10.946L23.121,12l.956-1.209Zm1.067,18.3H11V14.308h3.077Zm1.538,0V14.308a1.54,1.54,0,0,0-1.538-1.538H11a1.54,1.54,0,0,0-1.538,1.538v6.154H4.846V9.74l7.692-5.992,7.692,6V20.462Z",
    transform: "translate(-1 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebtn);
export default __webpack_public_path__ + "static/media/Homebtn.96c09c33df3e17236f2acb8ce6a66874.svg";
export { ForwardRef as ReactComponent };